import { RefObject } from 'react'
import { TooltipRefProps } from 'react-tooltip'

/**
 * Registro da instância única da tooltip de apoio ("i").
 *
 * O `InfoTooltipButton` precisa saber se a tooltip já está aberta na sua própria âncora (para não
 * alternar por engano quando o atraso do hover vence) e precisa poder fechá-la quando foi ele quem
 * a abriu por hover. O `CustomTooltipPresenter` é montado como irmão da árvore em `App.tsx`, então
 * não existe Provider envolvendo os botões — daí o registro em módulo, viável justamente porque a
 * instância da tooltip é única.
 */
let infoTooltipRef: RefObject<TooltipRefProps> | null = null

/** Registra a instância e devolve a função de baixa (para usar no cleanup do efeito). */
export function registerInfoTooltip(ref: RefObject<TooltipRefProps>) {
  infoTooltipRef = ref

  return () => {
    if (infoTooltipRef === ref) infoTooltipRef = null
  }
}

/** A tooltip está aberta e ancorada neste elemento? */
export function isInfoTooltipOpenFor(anchor: HTMLElement | null) {
  const tooltip = infoTooltipRef?.current
  if (!anchor || !tooltip?.isOpen) return false

  return tooltip.activeAnchor === anchor
}

/** Fecha a tooltip, mas só se ela ainda estiver ancorada neste elemento. */
export function closeInfoTooltipFor(anchor: HTMLElement | null) {
  if (!isInfoTooltipOpenFor(anchor)) return

  infoTooltipRef?.current?.close()
}
